/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Max_Characters_Per_SecondInputs */



/**
* | output |
* | --- |
* | "Max Characters Per Second (CPS)" |
*
* @param {Max_Characters_Per_SecondInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const max_characters_per_second = /** @type {((inputs?: Max_Characters_Per_SecondInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Max_Characters_Per_SecondInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Max caractères par seconde (CPS)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Maximale Zeichen pro Sekunde (CPS)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Numero massimo di caratteri al secondo (CPS)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Максимальное количество символов в секунду (CPS)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Máximo de caracteres por segundo (CPS)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("每秒最大字符数 (CPS)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1秒あたりの最大文字数（CPS）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रति सेकंड अधिकतम अक्षर (सीपीएस)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Número máximo de caracteres por segundo (CPS)")
	return /** @type {LocalizedString} */ ("Max Characters Per Second (CPS)")
});